import { createContext, useCallback } from 'react';
import useWebSocket from 'react-use-websocket';
import { useAppDispatch } from '../hooks/useAppDispatch';
import { organizerSlice } from '../store/slice/slice';
import { messengerEvents } from '../websocket/events';

const ws_url = window.location.origin.includes('localhost')
  || window.location.origin.includes('dev')
  || window.location.origin.includes('3.229.7.109')
  ? 'ws://3.229.7.109:3000/api/v1/ws'
  : 'wss://letsdugood.org.au/api/v1/ws';

export const SocketContext = createContext<any>({
  socket: null,
  sendEvent: (data: any) => {},
  sendMessage: (data: any) => {},
});

export const SocketProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const dispatch = useAppDispatch();

  const socket = useWebSocket(ws_url, {
    protocols: [localStorage.token],
    onOpen: () => {
      console.log('WebSocket connection established.');
      socket.sendMessage(
        JSON.stringify({ event: messengerEvents.getChats }),
      );
    },
    onMessage: (socketEvent) => {
      try {
        const parsedData = JSON.parse(socketEvent.data);
        switch (parsedData.event) {
          case messengerEvents.getChats:
            dispatch(organizerSlice.actions.setNoticePages(parsedData.data));
            break;
          case messengerEvents.sendNotice:
            socket.sendJsonMessage({
              event: 'getChats',
            });
            break;
          default:
            console.error('uncaught event');
            break;

        }
      }
      catch (err) {
        throw new Error();
      }
    },
  });

  const sendEvent = useCallback((data: any) => {
    socket.sendJsonMessage(data);
  }, []);

  const sendMessage = useCallback((data: any) => {
    socket.sendMessage(data);
  }, []);

  return (
    <SocketContext.Provider
      value={{
        socket,
        sendEvent,
        sendMessage,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};
